import React from 'react';
import { FormikProps } from 'formik';
import ATMLoadingButton from 'src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton';
import ATMTextField from 'src/components/UI/atoms/formFields/ATMTextField/ATMTextField';
import { AddDaysFormValues } from 'src/models/AddDays.model';
import { handleValidNumber } from 'src/utils/validations/numberInput';

type Props = {
  formikProps: FormikProps<AddDaysFormValues>;
  onClose: () => void;
};

const AddDaysForm = ({ formikProps, onClose }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className='p-4 flex flex-col gap-6'>
      <div className='flex justify-between items-center'>
        <div className='text-xl font-medium'>Add Days</div>
        <button type='button' className='hover:bg-hover' onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className='flex flex-col gap-4'>
      <div>
          <ATMTextField
            name='planName'
            required
            value={values?.planName}
            onChange={(e) => {
              setFieldValue('planName', e.target.value);
            }}
            label='Plan Name'
            placeholder='Enter Plan Name'
            onBlur={handleBlur}
          />
        </div>
      {/* Total Days */}
        <div>
          <ATMTextField 
          required
            name='day'
            value={values?.day}
            onChange={(e) => {
             handleValidNumber(e) && setFieldValue('day', e.target.value);
            }}
            label='Duration'
            placeholder='Enter Duration'
            onBlur={handleBlur}
          />
        </div>
       
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type='submit'>
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default AddDaysForm;